import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { SETTINGS } from '../../../../../core/config/common.settings';
import { FormBuilder, Validators } from '@angular/forms';
import { AppUtils } from '../../../../../core/config/app.utils';
import { CurrencyService } from '../../../../../core/services/currency.service';
import {
  amountFormatter,
  amountParser,
} from '../../../../../core/ult-functions/currency-calculation';

@Component({
  selector: 'app-add-edit-predefined-cost',
  templateUrl: './add-edit-predefined-cost.component.html',
  styleUrls: ['./add-edit-predefined-cost.component.scss'],
})
export class AddEditPredefinedCostComponent implements OnInit, OnDestroy {
  @Input() data?: any;
  @Input() mode?: string;
  @Input() index?: any;

  protected readonly SETTINGS = SETTINGS;
  predefinedCostForm: any;
  formErrors: any;
  fixedPercentSymbol: any[] = [];
  private langChangeSub?: Subscription;
  status = [
    {
      label: this.translocoService.translate(
        'settings.preferences.tourCosting.predefinedCost.status.active'
      ),
      value: true,
    },
    {
      label: this.translocoService.translate(
        'settings.preferences.tourCosting.predefinedCost.status.inactive'
      ),
      value: false,
    },
  ];
  currencies: any[] = [];

  formatter = amountFormatter;
  parser = amountParser;

  constructor(
    private modal: NzModalRef,
    private fb: FormBuilder,
    private currencyService: CurrencyService,
    private translocoService: TranslocoService
  ) {
    this.formErrors = {
      title: {},
      cost: {},
      costCalSymbol: {},
      currency: {},
      active: {},
      entryType: {},
    };
  }


  private getFixedPercentOptions(): Array<{ value: string; label: string; emoji: string }> {
    const lang = this.translocoService.getActiveLang();
    const filtered = SETTINGS.FIXED_PERCENT_SYMBOL.filter(item => item.language === lang);
    return (filtered.length ? filtered : SETTINGS.FIXED_PERCENT_SYMBOL.filter(item => item.language === 'en'))
      .map(({ value, label, emoji }) => ({ value, label, emoji }));
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
  }
  ngOnInit(): void {
    this.fixedPercentSymbol = this.getFixedPercentOptions();
    this.langChangeSub = this.translocoService.langChanges$.subscribe(() => {
      this.fixedPercentSymbol = this.getFixedPercentOptions();
    });
    this.getCurrencies().then();
    this.predefinedCostForm = this.fb.group({
      title: ['', [Validators.required]],
      cost: ['', [Validators.required]],
      costCalSymbol: ['', [Validators.required]],
      currency: [null],
      active: [true, [Validators.required]],
      entryType: ['PRE'],
    });
    this.predefinedCostForm.valueChanges.subscribe((form: any) => {
      this.formErrors = AppUtils.getFormErrors(
        this.predefinedCostForm,
        this.formErrors
      );
    });

    this.predefinedCostForm
      .get('costCalSymbol')
      .valueChanges.subscribe((value: any) => {
        if (value !== '') {
          if (value === this.SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.FIXED) {
            this.predefinedCostForm
              .get('currency')
              .addValidators([Validators.required]);
            this.predefinedCostForm.get('currency').updateValueAndValidity();
          } else {
            this.predefinedCostForm.patchValue({
              currency: null,
            });
            this.predefinedCostForm.get('currency').clearValidators();
            this.predefinedCostForm.get('currency').updateValueAndValidity();
          }
        }
      });

    if (this.mode === SETTINGS.PREDEFINED_COST_MODE.EDIT) {
      this.predefinedCostForm.patchValue(this.data[this.index]);
    }
  }

  async getCurrencies(): Promise<any> {
    this.currencies = await this.currencyService.getCurrencies();
  }

  handleCancel(): void {
    this.modal.close({ valid: false });
  }

  addEditPreCost(): void {
    if (this.mode === SETTINGS.PREDEFINED_COST_MODE.NEW) {
      this.data.push(this.predefinedCostForm.getRawValue());
      this.modal.close({
        valid: true,
        mode: this.mode,
        predefinedCost: this.data,
      });
    }

    if (this.mode === SETTINGS.PREDEFINED_COST_MODE.EDIT) {
      this.data[this.index] = this.predefinedCostForm.getRawValue();
      this.modal.close({
        valid: true,
        mode: this.mode,
        predefinedCost: this.data,
      });
    }
  }

  sortOrderCurrency(list: any[]): any {
    return list.sort((a, b): any => {
      return a.cc.localeCompare(b.cc);
    });
  }
}
